import { KeyboardEventHandler } from 'react'

// https://github.com/facebook/react/issues/11488#issuecomment-347775628
// Update formElement value then trigger blur event programmatically
export function setNativeValue(formElement, nextValue, triggerBlur) {
  const lastValue = formElement.value
  const event: any = new Event('blur', { bubbles: true })

  formElement.value = nextValue
  const tracker = formElement._valueTracker
  if (tracker) {
    tracker.setValue(lastValue)
  }

  if (triggerBlur) {
    formElement.dispatchEvent(event)
  }
}

export const replaceEmptyToNull = (str: string | null): string | null => {
  if (str === null || str.trim() === '') {
    return null
  }
  return str
}

export const isEnterKey = (
  event: Pick<KeyboardEvent, 'key' | 'isComposing' | 'keyCode'>
): boolean => {
  // IMEの変換確定時にはisComposingがfalseになる場合もあるため、keyCodeも確認する。
  return event.key === 'Enter' && !event.isComposing && event.keyCode !== 229
}

export const createEnterKeyHandler = (
  onEnter: () => void
): KeyboardEventHandler<HTMLInputElement> => event => {
  if (isEnterKey(event.nativeEvent)) {
    event.preventDefault()
    // 長押し中もフォームのデフォルト送信を抑止し、検索は最初の1回だけ実行する。
    if (event.repeat) {
      return
    }
    onEnter()
  }
}
